import { render, staticRenderFns } from "./StateList.vue?vue&type=template&id=aa485960&"
import script from "./StateList.vue?vue&type=script&lang=js&"
export * from "./StateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports